import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { JuneaLogo } from '@/components/junea-logo'
import { useAuthStore } from '@/stores/auth-store'

export const Route = createFileRoute('/_auth')({
  beforeLoad: () => {
    if (useAuthStore.getState().token !== null) {
      throw redirect({ to: '/' })
    }
  },
  component: AuthLayout,
})

function AuthLayout() {
  return (
    <div className="bg-background flex min-h-screen">
      <div className="flex w-full flex-col px-8 py-6 md:w-1/2 md:px-16 lg:px-24">
        <JuneaLogo className="w-28" />
        <div className="flex flex-1 items-center">
          <div className="w-full max-w-md">
            <Outlet />
          </div>
        </div>
      </div>
      <div className="hidden p-2 pl-0 md:block md:w-1/2">
        <img src="/images/auth-hero.webp" alt="" className="size-full rounded-xl object-cover" />
      </div>
    </div>
  )
}
